import { FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED } from 'actions/updateAutochargeActions'; 
import { toast } from 'react-toastify';

const initialState = {
  isLoader: false,
  customers: [],
  search: '',
  page: 1,
  page_no:'',
  limit: 10,
  totalPages: 1,
  total: 1,
};

const updateAutochargeReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.REQUEST: {
      return { ...state, isLoader: true , page_no:''};
    }

   
    case FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.SUCCESS: {
      
      return {
        ...state,
        isLoader: false,
        customers: payload.data?.results, 
        search: payload.config?.params?.search || state.search, 
        page: payload.data?.page,        
        page_no:payload.config?.params?.page, 
        limit: payload.data?.limit,       
        totalPages: payload.data?.totalPages, 
        total: payload.data?.totalResults,   
      };
    }

    case FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.FAIL: {
      toast.error(payload?.message || 'Failed to fetch customers with autocharge disabled');
      return { ...state, isLoader: false };
    }

    default:
      return state;
  }
};

export default updateAutochargeReducer;

